// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"69374165","125":"4cf52e57","198":"629506b5","404":"2fd1372e","498":"849bccf3","930":"99aad302"}[chunkId] + ".chunk.js";
};